$(document).ready(function(){
  
    $(document).mouseup(function (e) {
    var container = $('.header-nav');
    if (!container.is(e.target) && container.has(e.target).length === 0 && $('.header-nav').hasClass('toggle')) {
      $('.header-nav').removeClass('toggle')
      $('.overlay-content').removeClass('overlay')
      $('body').removeClass('opened-drawer');
    }
    
      var search = $('.search-bar-container');
      if (!search.is(e.target) && search.has(e.target).length === 0 && $('.search-bar-container').hasClass('search-bar-container-display')) {
        $('.search-bar-container').removeClass('search-bar-container-display');
        $('.overlay-content').removeClass('overlay');
        $('body').removeClass('opened-drawer');
      }
  });
  
  
  $(document).on('click', '.mobile-header', function() {
    $('.header-nav').toggleClass('toggle');
    $('body').toggleClass('opened-drawer');
    $('.overlay-content').toggleClass('overlay');
  });
  
  $(document).on('click', '.close-button', function() {
    $('.header-nav').removeClass('toggle');
    $('body').removeClass('opened-drawer');
    $('.overlay-content').removeClass('overlay');
  });

    $(document).on('click','.sidebar-menu .accordion',function(event) {
    console.log('.accordion');
    event.preventDefault();
    $('.accordion-plus-icon').removeClass('is-open');
    if($(this).next().hasClass('show')) {
      $(this).next().removeClass('show');
      $(this).next().slideUp(350);
      $(this).find('.accordion-plus-icon').removeClass('is-open');
    } else {
      $(this).parent().parent().find('li .dropdown-menus').removeClass('show');
      $(this).parent().parent().find('li .dropdown-menus').slideUp(350);
      $(this).next().toggleClass('show');
      $(this).next().slideToggle(350);
      $(this).find('.accordion-plus-icon').addClass('is-open');
    }
  });
  
  $(document).ready(function() {
    $(document).on('click', '.footer-content .accordian-title', function () {
      event.preventDefault();

      if ($(this).next('.accordian-inner').hasClass('show')) {
        $(this).next('.accordian-inner').removeClass('show').slideUp(300);
        $(this).find('.plus-icon').removeClass('is-open');
      } else {
        $('.plus-icon').removeClass('is-open');
        $('.accordian-inner').removeClass('show').slideUp(300);
        $(this).next().addClass('show').slideDown(350);
        $(this).find('.plus-icon').addClass('is-open');
      }
    });
  });
  
  $('.search-icon').click(function () {
    $('body').toggleClass('opened-drawer');
    $('.search-bar-container').toggleClass('search-bar-container-display');
    $('.overlay-content').toggleClass('overlay');
  });
  
  $('.search-close-button').click(function () {
    $('body').toggleClass('opened-drawer');
    $('.search-bar-container').toggleClass('search-bar-container-display');
    $('.overlay-content').toggleClass('overlay');

  });
  
  
  $('ul.tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $('#'+tab_id).addClass('current');
  })
    

//   $('.header__icon--cart').click(function () {
//     $('.cart-notification').toggleClass('active');
//   });

//    var slider = new Swiper('.main-product', {
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//     loop: true,
//      spped: 1000,
//     slidesPerView: 1,
//     autoplay: false,
//     navigation: {
//       nextEl: ".main-product .swiper-button-next",
//       prevEl: ".main-product .swiper-button-prev",
//     },
//   });
  
//   var thumbs = new Swiper('.main-product-thumbnail', {
// //     pagination: {
// //       el: ".swiper-pagination",
// //       clickable: true,
// //     },
//     slidesPerView: 4,
//     loop:true,
//     autoplay: false,
//     slideToClickedSlide: true,
//     spaceBetween: 10,
//     navigation: {
//       nextEl: ".main-product-thumbnail .swiper-button-next",
//       prevEl: ".main-product-thumbnail .swiper-button-prev",
//     },
//   });
// //   slider.controller.control = thumbs;
// //   thumbs.controller.control = slider;

  
    
//   $('.main-product').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     adaptiveHeight: true,
//     asNavFor: '.main-product-thumbnail',
//     prevArrow: '<button type="button" class="slick-prev pull-left"><svg class="left-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title/><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z"/></g></svg></button>',
//     nextArrow: '<button type="button" class="slick-next pull-right"><svg class="right-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title/><g data-name="1" id="_1"><path d="M202.1,450a15,15,0,0,1-10.6-25.61L365.79,250.1,191.5,75.81A15,15,0,0,1,212.71,54.6l184.9,184.9a15,15,0,0,1,0,21.21l-184.9,184.9A15,15,0,0,1,202.1,450Z"/></g></svg></button>',
        
//   })
    
//   $('.main-product-thumbnail').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     asNavFor: '.main-product',
//     dots: false,
//     focusOnSelect: true,
//     arrows: false,
//     prevArrow: '<button type="button" class="slick-prev pull-left"><svg class="left-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title/><g data-name="1" id="_1"><path d="M353,450a15,15,0,0,1-10.61-4.39L157.5,260.71a15,15,0,0,1,0-21.21L342.39,54.6a15,15,0,1,1,21.22,21.21L189.32,250.1,363.61,424.39A15,15,0,0,1,353,450Z"/></g></svg></button>',
//     nextArrow: '<button type="button" class="slick-next pull-right"><svg class="right-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><title/><g data-name="1" id="_1"><path d="M202.1,450a15,15,0,0,1-10.6-25.61L365.79,250.1,191.5,75.81A15,15,0,0,1,212.71,54.6l184.9,184.9a15,15,0,0,1,0,21.21l-184.9,184.9A15,15,0,0,1,202.1,450Z"/></g></svg></button>',

//   });
  
  
  
});